import React from 'react'
import {useNavigate } from 'react-router-dom'

export default function ClubCreatedModal({id}) {
    const navi = useNavigate();
    const handleClick = () => {
        navi(`/myoneClub/${id}`)
    }

    //styled
    return (
        <div className="send-modal-overlay">
      
        <div className="send-modal">
        <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Club Created</p></div> 
        <p>The club has been successfully created.</p>

            <div className="send-modal-footer">
              <button className="saveChanges-button mx-3" onClick={handleClick}>
                Confirm
               
                </button>
            </div>
        
        </div>
      </div>
      )
    }
    